import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
// import home from '@/views/home/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        component: Layout,
        children: [{
            path: '/',
            component: () => import('@/views/home/index'),
            name: 'home',
            meta: {
                title: '首页',
            }
        },{
            path: 'server',
            component: () => import('@/views/server/index'),
            name: 'server',
            meta: {
                title: '服务项目',
            }
        },{
            path: 'server/detail',
            component: () => import('@/views/server/detail'),
            name: 'server',
            meta: {
                title: '详情',
            }
        },{
            path: 'reservation',
            component: () => import('@/views/reservation/index'),
            name: 'reservation',
            meta: {
                title: '免费预约',
            }
        },{
            path: 'master',
            component: () => import('@/views/master/index'),
            name: 'master',
            meta: {
                title: '平台师傅',
            }
        },{
            path: 'master/detail',
            component: () => import('@/views/master/detail'),
            name: 'master',
            meta: {
                title: '平台师傅详情',
            }
        },{
            path: 'cooperate',
            component: () => import('@/views/cooperate/index'),
            name: 'cooperate',
            meta: {
                title: '加盟合作',
            }
        },{
            path: 'codeQuery',
            component: () => import('@/views/codeQuery/index'),
            name: 'codeQuery',
            meta: {
                title: '故障代码查询',
            }
        },{
            path: 'codeQuery/detail',
            component: () => import('@/views/codeQuery/detail'),
            name: 'codeQueryDetail',
            meta: {
                title: '详情',
            }
        },{
            path: 'repairWay',
            component: () => import('@/views/repairWay'),
            name: 'repairWay',
            meta: {
                title: '维修小智慧',
            }
        },{
            path: 'repairWay/detail',
            component: () => import('@/views/repairWay/detail'),
            name: 'repairWayDetail',
            meta: {
                title: '详情',
            }
        },{
            path: 'case',
            component: () => import('@/views/case'),
            name: 'case',
            meta: {
                title: '案例',
            }
        },{
            path: 'case/detail',
            component: () => import('@/views/case/detail'),
            name: 'caseDetail',
            meta: {
                title: '案例详情',
            }
        },{
            path: 'news',
            component: () => import('@/views/news'),
            name: 'news',
            meta: {
                title: '新闻咨询',
            }
        },{
            path: 'news/detail',
            component: () => import('@/views/news/detail'),
            name: 'newsDetail',
            meta: {
                title: '咨询详情',
            }
        },
        {
            path: 'aboutUs',
            component: () => import('@/views/aboutUs/index'),
            name: 'aboutUs',
            meta: {
                title: '关于我们',
            }
        },
        {
            path: 'search',
            component: () => import('@/views/search/index'),
            name: 'search',
            meta: {
                title: '搜索',
            }
        },
        {
            path: 'agreement',
            component: () => import('@/views/agreement/index'),
            name: 'agreement',
            meta: {
                title: '协议',
            }
        }
        ]
        
        
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js